module.exports = __webpack_public_path__ + "img/Portrait_Square.6bb83190.jpg";